import React, { useState, useEffect, useContext } from "react";
import { PlayersContext } from "./PlayersContext";
import CardPlayer from "./CardPlayer";
import TeamCard from "./TeamCard";
import SoonMatches from "./GetMatches";
import "../style.css";
import "../team-stats.css";
import "../all-players-stats.css";
import AllPlayersStats from "./AllPlayersStats";

function Dashboard() {
  const { playersData, globalData } = useContext(PlayersContext);
  const [selectedPlayerId, setSelectedPlayerId] = useState(null);
  const [allParticipants, setAllParticipants] = useState([]);
  const [playerStats, setPlayerStats] = useState(null);
  const [shortPatch, setShortPatch] = useState(null);

  useEffect(() => {
    if (!globalData || !playersData.length) return;

    const fetchData = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const matchId = params.get("match") || "113503500599535529";

        const delaySeconds = 35;
        const date = new Date(Date.now() - delaySeconds * 1000);
        const flooredSeconds = Math.floor(date.getSeconds() / 10) * 10;
        date.setSeconds(flooredSeconds);
        date.setMilliseconds(0);
        const time = date.toISOString();

        const response = await fetch(
          `https://feed.lolesports.com/livestats/v1/details/${matchId}?startingTime=${time}`
        );
        if (!response.ok) throw new Error("Erreur HTTP " + response.status);

        const data = await response.json();
        const participants = Object.values(data.frames["0"].participants);

        var shortPatch = globalData.patchVersion
          .split(".")
          .slice(0, 2)
          .join(".");
        setShortPatch(shortPatch);

        participants.forEach((user) => {
          const found = playersData.find(
            (obj) => obj.participantId == user.participantId
          );
          if (found) {
            user.summonerName = found.summonerName;
            user.role = found.role;
            user.currentHealth = found.currentHealth;
            user.maxHealth = found.maxHealth;
            user.championId = found.championId;
          }
          user.shortPatch = shortPatch;
        });

        setAllParticipants(participants);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [globalData, playersData]);

  useEffect(() => {
    if (!selectedPlayerId || !allParticipants.length) return;

    const user = allParticipants.find(
      (p) => p.participantId == selectedPlayerId
    );
    setPlayerStats(user);
  }, [selectedPlayerId, allParticipants]);

  if (!playersData.length || !globalData)
    return <div>Chargement des joueurs...</div>;

  return (
    <div className="dashboard">
      <div>
        <label>Sélectionnez un joueur {globalData.patchVersion}: </label>
        <select onChange={(e) => setSelectedPlayerId(e.target.value)}>
          <option value="">-- Choisir --</option>
          {playersData.map((p) => (
            <option key={p.participantId} value={p.participantId}>
              {p.summonerName}
            </option>
          ))}
        </select>
      </div>
      <SoonMatches />
      {playerStats && <CardPlayer player={playerStats} />}
      {globalData && <TeamCard player={globalData} />}
      {playersData && shortPatch && <AllPlayersStats players={playersData} shortPatch={shortPatch} />}
    </div>
  );
}

export default Dashboard;
